import React from 'react';
import { formatNumber } from "../utils/numberFormat";

export default function ComponentDetailModal({ comp, onClose }) {
    if (!comp) return null;

    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: 'white', borderRadius: 8, maxWidth: 900, width: '95%', padding: 20, boxShadow: '0 8px 24px rgba(0,0,0,0.2)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                    <h3 style={{ margin: 0 }}>{comp.nombre} <small style={{ color: '#666', marginLeft: 8 }}>[{comp.type || comp.tipo || '—'}]</small></h3>
                    <button onClick={onClose} style={{ background: '#ef4444', color: 'white', border: 'none', padding: '6px 10px', borderRadius: 6 }}>Cerrar</button>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 260px', gap: 20 }}>
                    <div>
                        <h4>Ítems</h4>
                        {Array.isArray(comp.items) && comp.items.length > 0 ? (
                            <table className="table" style={{ width: '100%' }}>
                                <thead>
                                    <tr><th>Nombre</th><th>Costo</th></tr>
                                </thead>
                                <tbody>
                                    {comp.items.map((it, i) => (
                                        <tr key={i}><td>{it.nombre}</td><td>${formatNumber(it.costo)}</td></tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <div>
                                <p style={{ color: '#666' }}>No hay ítems registrados.</p>
                                {comp.items && console.warn('comp.items is not an array:', comp.items)}
                            </div>
                        )}

                        <div style={{ marginTop: 16 }}>
                            <strong>Resumen:</strong>
                            <div>Id: {comp.id}</div>
                            <div>Costo total: ${formatNumber(comp.costoTotal || 0)}</div>
                            <div>Costo materiales: ${formatNumber(comp.costoMateriales || 0)}</div>
                        </div>
                    </div>

                    <aside style={{ borderLeft: '1px solid #eee', paddingLeft: 12 }}>
                        <h4>Metadatos</h4>
                        <div><strong>Nombre</strong>: {comp.nombre}</div>
                        <div><strong>Tipo</strong>: {comp.type || comp.tipo || '—'}</div>
                        <div><strong>Items</strong>: {comp.items?.length || 0}</div>
                    </aside>
                </div>
            </div>
        </div>
    );
}
